// Internal (non-marketing) route prefixes: admin, sign-in and the borrower
// portal. Mirrors INTERNAL_PREFIXES in public/index.html (the GA guard) — keep
// the two lists in sync.
export const INTERNAL_PREFIXES = ['/dashboard', '/login', '/borrower', '/register'];

export function isInternalPath(pathname) {
  let p = (pathname || '/').split('?')[0].split('#')[0].toLowerCase();
  if (p.length > 1 && p.endsWith('/')) p = p.slice(0, -1);
  return INTERNAL_PREFIXES.some((pre) => p === pre || p.startsWith(`${pre}/`));
}

export default isInternalPath;
